import {i18n} from "@/plugins/i18n";
import mixins from "@/mixins";

export class PropertyHold {
    columns = [];
    id      = 'id';

    fillAbles = [
        [
            'propertyName',
            i18n.t('propertyName'),
            true
        ],
        [
            'name',
            i18n.t('name'),
            true
        ],
        [
            'customerId',
            i18n.t('customerId'),
            true,
            false
        ],
        [
            'isCustomer',
            i18n.t('isCustomer'),
            true,
            false
        ],
        [
            'payType',
            i18n.t('payType'),
            true,
            false
        ],
        [
            'bankName',
            i18n.t('bankName'),
            true,
            false
        ],
        [
            'bankSlipNumber',
            i18n.t('bankSlipNumber'),
            true,
            false
        ],
        [
            'bankSlipDate',
            i18n.t('bankSlipDate'),
            true,
            false
        ],
        [
            'bankSlipNote',
            i18n.t('bankSlipNote'),
            true,
            false
        ],
        [
            'phone',
            i18n.t('phone'),
            true
        ],
        [
            'holdPayment',
            i18n.t('holdPayment'),
            true
        ],
        [
            'date',
            i18n.t('date'),
            true
        ],
        [
            'deadline',
            i18n.t('deadline'),
            true
        ],
        [
            'note',
            i18n.t('note'),
            true
        ],
        [
            'attachment',
            i18n.t('attachment'),
            true
        ],
        [
            'controls',
            i18n.t('controls'),
            false
        ]
    ];

    getColumns() {
        this.columns = [
            {
                label: i18n.t('id'),
                name: 'id',
                sort: false,
                visibility: mixins.projectTenant() !== 'MassHills',
                uniqueId: true
            },
        ];
        this.fillAbles.map(e => {
            this.columns.push({
                name: e[0],
                label: e[1],
                sort: e[2],
                visibility: e[3] ?? true
            })
        })
        return this.columns;
    }
}
